import { UploadImageField } from './UploadImageField'
import { withUploadImageField } from './withUploadImageField'

const ConnectedUploadCover = withUploadImageField(UploadImageField)

export { ConnectedUploadCover as UploadImageField }
